import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/lib/i18n";
import App from "@/App";
import { registerSW } from "@/lib/registerSW";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Hand over from the branded boot shell (public/index.html) only after the
// first real paint, so the guest never sees a white flash between them.
requestAnimationFrame(() => {
  requestAnimationFrame(() => window.__hideBootSplash?.());
});

registerSW();
